// Dates and times across the network are shown in San Francisco time (America/Los_Angeles).
//
// Why fix a timezone at all: the sites target the US, UK and Europe, and the team publishing them sits
// in India. Formatting in the viewer's own zone meant an article published Monday evening in California
// showed as Tuesday to the editor, and "published 2 hours ago" disagreed with itself between readers.
// One editorial clock removes that whole class of confusion, and US Pacific is the audience we write for.
export const SITE_TZ = 'America/Los_Angeles';

const parse = (value) => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** "21 September 2026" in San Francisco time. */
export function formatDate(value, opts = {}) {
  const d = parse(value);
  if (!d) return '';
  return d.toLocaleDateString('en-GB', {
    day: 'numeric', month: 'long', year: 'numeric', timeZone: SITE_TZ, ...opts,
  });
}

/** "21 Sep 2026" — for cards and tight rows. */
export function formatDateShort(value) {
  return formatDate(value, { month: 'short' });
}

/** "21 September 2026, 3:42 PM PDT" — when the hour genuinely matters. */
export function formatDateTime(value) {
  const d = parse(value);
  if (!d) return '';
  return d.toLocaleString('en-GB', {
    day: 'numeric', month: 'long', year: 'numeric',
    hour: 'numeric', minute: '2-digit', timeZoneName: 'short', timeZone: SITE_TZ,
  });
}

/** "3 hours ago", falling back to the date once it stops being useful. */
export function timeAgo(value) {
  const d = parse(value);
  if (!d) return '';
  const secs = Math.round((Date.now() - d.getTime()) / 1000);
  if (secs < 60) return 'just now';
  const mins = Math.round(secs / 60);
  if (mins < 60) return `${mins} minute${mins === 1 ? '' : 's'} ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  const days = Math.round(hours / 24);
  if (days <= 7) return `${days} day${days === 1 ? '' : 's'} ago`;
  return formatDateShort(d);
}

/** Today's date in San Francisco, as YYYY-MM-DD. Use for date inputs and "is this current" checks. */
export function todayInSiteTz() {
  return new Date().toLocaleDateString('en-CA', { timeZone: SITE_TZ });
}
